export default class apiRequest {
  apiBaseUrl = "https://fabuapi.erpsystem.lk/";
  systemKey = "QndFdGowMmJqSUFYYVlQTVJXMktVNlEzRTE4TVBLODRuSGFxcGxoZUpUQT0=";
  cache_timeout = 20000;

  constructor(baseUrl, auth = false, csrf = false) {
    this.baseUrl = this.isValidUrl(baseUrl)
      ? baseUrl
      : this.apiBaseUrl + baseUrl;
    this.method = "POST";
    this.headers = {
      "Content-Type": "application/json",
      Origin: window.location.origin,
    };
    this.isJSONStringify = true;
    this.csrf = csrf;

    if (auth) {
      this.setHeaders([
        {
          key: "Authorization",
          value: `Bearer ${localStorage.getItem("token")}`,
        },
      ]);
    }
  }

  async getCSRFToken() {
    const response = await fetch(this.apiBaseUrl + "get_csrf", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        system_key: this.systemKey,
      }),
    });
    const data = await response.json();

    if (data.status !== "success") {
      return null;
    }

    return data.token;
  }

  isValidUrl(url) {
    return /^(ftp|http|https):\/\/[^ "]+$/.test(url);
  }

  setHeaders(headerArr) {
    for (const { key, value } of headerArr) {
      this.headers[key] = value;
    }
  }

  setMethod(method) {
    this.method = method;
  }

  setJSONStringify(status) {
    this.isJSONStringify = status;
  }

  async send(
    request_data = {},
    successCallback,
    endPoint,
    useAppUser = false,
    cacheKey = null,
    cacheTimeout = null
  ) {
    const actual_endpoint = endPoint || this.baseUrl;
    const now = Date.now();

    if (cacheKey) {
      const cache = JSON.parse(localStorage.getItem(cacheKey) || "{}");
      const cachedItem = cache[actual_endpoint];
      const timeout = cacheTimeout || this.cache_timeout;

      if (cachedItem && now - cachedItem.timestamp < timeout) {
        return successCallback
          ? successCallback(cachedItem.data)
          : cachedItem.data;
      }
    }

    const headers = { ...this.headers };

    if (useAppUser) {
      headers["X-App-User"] = localStorage.getItem("token");
    }

    if (this.csrf) {
      headers["X-CSRF-Token"] = await this.getCSRFToken();
    }

    try {
      const response = await fetch(actual_endpoint, {
        method: this.method,
        headers,
        body: this.isJSONStringify
          ? JSON.stringify(request_data)
          : request_data,
      });

      if (response.status == 403) {
        window.location.href = "/access_denied";
        return null;
      }

      const data = await response.json();

      if (data.status === "denied") {
        if (useAppUser) {
          localStorage.removeItem("token");
        } else if (localStorage.getItem("token")) {
          localStorage.setItem("token_expired", "1");
        }
      }

      if (data.status === "success" && cacheKey) {
        localStorage.setItem(
          cacheKey,
          JSON.stringify({
            [actual_endpoint]: {
              timestamp: now,
              data,
            },
          })
        );
      }

      return successCallback ? successCallback(data) : data;
    } catch (error) {
      console.error("API request failed:", error);
      return null;
    }
  }

  async sendAndCache(
    cacheKey,
    cacheTimeout,
    request_data = {},
    successCallback,
    endPoint
  ) {
    return this.send(
      request_data,
      successCallback,
      endPoint,
      false,
      cacheKey,
      cacheTimeout
    );
  }

  async sendWithAppUser(request_data = {}, successCallback, endPoint) {
    return this.send(request_data, successCallback, endPoint, true);
  }
}
